import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
import FullScreenModal from './FullScreenModal';
const FullScreenModalHoc = (ChildComponent) => {
    const FullScreenModalHocInner = (props) => {
        const { className, hideFullModal, isShow } = props;
        return (_jsx(FullScreenModal, Object.assign({ className: className, hideFullModal: hideFullModal, isShow: isShow }, { children: _jsx(ChildComponent, Object.assign({}, props)) })));
    };
    FullScreenModalHocInner.propTypes = {
        className: propStr(),
        hideFullModal: propFunc().isRequired,
        isShow: propBool().isRequired,
    };
    FullScreenModalHocInner.defaultProps = {
        className: '',
    };
    return FullScreenModalHocInner;
};
FullScreenModalHoc.propTypes = {
    className: propStr(),
    hideFullModal: propFunc().isRequired,
    isShow: propBool().isRequired,
};
FullScreenModalHoc.defaultProps = {
    className: '',
};
export default FullScreenModalHoc;
